export const ticketList = [
    {
        ticketID: 1546,
        ticketTypeName: "دیر رسیدن کالا",
        ticketTitle: "دیر رسیدن کالا",
        userName: "893",
        customerFirstName: "کاربر ",
        customerLastName: "1",
        importanceLevel: 2,
        status: 0,
        ticketCreatedDateTime: "1401/09/01 00:17:00",
        lastResponseDateTime: "1401/09/01 00:17:00",
        totalMessages: 1,
        value: null,
        hasHistory: false,
        customerTicketMessages: null,
    },
    {
        ticketID: 1547,
        ticketTypeName: "اختلال در مرحله پرداخت",
        ticketTitle: "اختلال در مرحله پرداخت",
        userName: "893",
        customerFirstName: "کاربر",
        customerLastName: "2",
        importanceLevel: 2,
        status: 0,
        ticketCreatedDateTime: "1401/09/11 20:53:17",
        lastResponseDateTime: "1401/09/11 20:53:17",
        totalMessages: 1,
        value: null,
        hasHistory: false,
        customerTicketMessages: null,
    },
    {
        ticketID: 1548,
        ticketTypeName: "برگشت خوردن سفارش",
        ticketTitle: "برگشت خوردن سفارش",
        userName: "893",
        customerFirstName: "کاربر",
        customerLastName: "3",
        importanceLevel: 2,
        status: 0,
        ticketCreatedDateTime: "1401/09/12 11:33:13",
        lastResponseDateTime: "1401/09/12 11:33:13",
        totalMessages: 1,
        value: null,
        hasHistory: false,
        customerTicketMessages: null,
    },
]
